import { render, staticRenderFns } from "./ContentReferenceWidget.vue?vue&type=template&id=165a3662&scoped=true&"
import script from "./ContentReferenceWidget.vue?vue&type=script&lang=js&"
export * from "./ContentReferenceWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContentReferenceWidget.vue?vue&type=style&index=0&id=165a3662&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a3662",
  null
  
)

export default component.exports